import type {IdentityProviderT} from '@freckle/educator-entities/ts/roster/identity-provider'
import {getIdpLabel} from '@freckle/educator-entities/ts/roster/identity-provider'
import {H3} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import ConfirmButton from '@freckle/school/ts/rostering/components/common/confirm-button'
import {MergeDuplicateStudents} from '@freckle/school/ts/rostering/components/common/merge-duplicate-students'
import {cleanUpRosterWrapper} from './clean-up-roster.module.scss'

type Props = {
  onStart: () => void
  confimButtonEnabled: boolean
  onCheckboxChange: () => void
  isMergeChecked: boolean
  activeIdps: Set<IdentityProviderT>
  numUnmanagedStudents: number
}

export function CleanUpRoster(props: Props) {
  const {
    isMergeChecked,
    onStart,
    confimButtonEnabled,
    onCheckboxChange,
    activeIdps,
    numUnmanagedStudents
  } = props
  const {t} = useSafeTranslation()

  const btnText = isMergeChecked
    ? t('IMPORT_ROSTER_CLEAN_UP_ROSTER_BUTTON_MERGE_AND_START')
    : t('IMPORT_ROSTER_CLEAN_UP_ROSTER_BUTTON_START')

  const idps = Array.from(activeIdps)

  return (
    <div className={cleanUpRosterWrapper}>
      <H3>{t('IMPORT_ROSTER_CLEAN_UP_ROSTER_H3')}</H3>

      <MergeDuplicateStudents
        isChecked={isMergeChecked}
        onChange={onCheckboxChange}
        activeIdpsString={idps.length === 1 ? getIdpLabel(t, idps[0]) : t('IDPS_PLURALIZED')}
        numUnmanagedStudents={numUnmanagedStudents}
      />

      <ConfirmButton
        onConfirm={confimButtonEnabled ? () => onStart() : undefined}
        dataTest="rostering-import-roster"
        text={btnText}
        warn={t('IMPORT_ROSTER_CLEAN_UP_ROSTER_WARN')}
      />
    </div>
  )
}
